import { render, staticRenderFns } from "./ConfirmaTermoModal.vue?vue&type=template&id=0baeb6ef&scoped=true&"
import script from "./ConfirmaTermoModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmaTermoModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmaTermoModal.vue?vue&type=style&index=0&id=0baeb6ef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baeb6ef",
  null
  
)

export default component.exports